export const SEARCH_PARAMS_TO_OMIT_FOR_SEARCHES = [
  'layout',
  'selectedOfferId',
  'redirectId',
  'closeSearchBox',
  'offerFilters',
  'roomFilters',
  'roomUserSearch'
]

export enum OfferAccessFlow {
  PrivateLockedDeal = 'privateLockedDeal',
  AppLocked = 'appLocked',
  SMSConfirmation = 'smsConfirmation',
  RegularDeal = 'regularDeal'
}

export type OfferAccessFlowSettings = {
  // if the offer is locked
  isLocked: boolean
  // which type of auth flow does offer require
  flowType?: OfferAccessFlow
}
